import AcceptTermsLabel from './AcceptTermsLabel';

export default AcceptTermsLabel;
